"use client";

import dynamic from "next/dynamic";

function DevInspectorPlaceholder() {
  return null;
}

const CcDevInspoInspectorGate =
  process.env.NODE_ENV !== "production"
    ? dynamic(
        () =>
          import("@/components/dev/CcDevInspoInspectorGate").then(
            (mod) => mod.CcDevInspoInspectorGate,
          ),
        { ssr: false },
      )
    : DevInspectorPlaceholder;

export function CcDevInspoInspectorRoot() {
  return <CcDevInspoInspectorGate />;
}
